import { VildEncodingStatusType } from 'app/models/enums';

import { VildData } from './vilddata.model';
import { VildVersion } from './vildversion.model';

export class AlertcPoint {
  public id: number;
  public siterecordId: number;
  public vildVersion: VildVersion;
  public vildEncodingStatus: VildEncodingStatusType;
  public locationCountryCode: string;
  public directionCoded: string;
  public directionSense: boolean;
  public vildLocation: VildData;
  public offsetDistance: number;
  public displayLatitude: number;
  public displayLongitude: number;
  public carriageway: string; // CarriagewayType
}



// WEBPACK FOOTER //
// ./src/app/models/alertcpoint.model.ts